import { useState } from 'react';
import { Share, X, PlusSquare } from 'lucide-react';

const KEY = 'wo_install_hint_dismissed';
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const isStandalone = () => window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;

export function InstallHint() {
  const [show, setShow] = useState(() => isIos() && !isStandalone() && !localStorage.getItem(KEY));
  if (!show) return null;
  const dismiss = () => { localStorage.setItem(KEY, '1'); setShow(false); };
  return (
    <div className="md:hidden fixed inset-x-3 top-[calc(4rem+env(safe-area-inset-top))] z-30 flex items-start gap-3 rounded-2xl border border-[#334155] bg-[#111827]/95 p-3.5 shadow-2xl backdrop-blur-xl" data-testid="install-hint">
      <img src="/apple-touch-icon.png" alt="" className="h-11 w-11 shrink-0 rounded-xl" />
      <div className="min-w-0 flex-1 text-xs text-slate-300">
        <p className="text-sm font-semibold text-white">Install WholesaleOffers</p>
        <p className="mt-0.5">Tap <Share className="inline h-3.5 w-3.5 text-blue-400" /> Share, then <PlusSquare className="inline h-3.5 w-3.5 text-blue-400" /> <b>Add to Home Screen</b> for a full-screen app.</p>
      </div>
      <button onClick={dismiss} className="-m-1 p-1.5 text-slate-500 hover:text-white" data-testid="install-hint-dismiss" aria-label="Dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
}
